<template>
  <div class="card card-table flex-fill card-details person-info">
    <div class="person-profile">
      <h4>Company Information</h4>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <div class="inform-content">
          <label>Company Name</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="inform-content">
          <label>Company Email Address</label>
          <input type="email" class="form-control" />
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="inform-content">
          <label>Phone Number</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="inform-content">
          <label>Fax</label>
          <input type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="inform-content">
          <label>Website</label>
          <input type="text" class="form-control" />
        </div>
      </div>
    </div>
  </div>
</template>
